module.exports = __webpack_public_path__ + "img/hostinger.1e8898ae.png";